// App.js - Enhanced to Match Your Existing Sidebar IDs
import React, { useState } from 'react';
import './App.css';
import Sidebar from './Sidebar';
import Dashboard from './Dashboard';
import GovernmentIntel from './GovernmentIntel';
import Watchlist from './Watchlist';
import OpenTrades from './OpenTrades';
import CompletedTrades from './CompletedTrades';
import TradeAnalysis from './TradeAnalysis';
import PortfolioAnalysis from './PortfolioAnalysis';
import Operations from './Operations';
import Settings from './Settings';

function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [selectedTradeId, setSelectedTradeId] = useState(null);

  const renderCurrentPage = () => {
    switch(currentPage) {
      case 'dashboard':
        return <Dashboard />;
      case 'government':
        return <GovernmentIntel />;
      case 'watchlist':
        return <Watchlist />;
      case 'trades':  // Matches your sidebar ID
        return <OpenTrades />;
      case 'completed':  // Matches your sidebar ID
        return <CompletedTrades onTradeSelect={setSelectedTradeId} />;
      case 'analysis':  // Matches your sidebar ID
        return <TradeAnalysis tradeId={selectedTradeId} />;
      case 'analytics':  // Matches your sidebar ID
        return <PortfolioAnalysis />;
      case 'operations':
        return <Operations />;
      case 'settings':
        return <Settings />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="App">
      <div className="flex h-screen bg-gray-900">
        <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
        <main className="flex-1 overflow-y-auto bg-gray-900">
          {renderCurrentPage()}
        </main>
      </div>
    </div>
  );
}

export default App;